import NewReleasesIcon from '@mui/icons-material/NewReleases';
import { IconButton, Tooltip } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';
import { useVersionCheck } from './useVersionCheck';

const versionUpdateTooltipMessage = defineMessage({
  id: 'ui.versionChecker.newVersionAvailableReload',
  defaultMessage: 'Nueva versión disponible, click para recargar',
});

/**
 * Renders an icon button next to the sidebar logout when a new version is available
 * but the full alert was already shown in the last 24h (cooldown). Click reloads the app.
 */
export function VersionUpdateSidebarButton() {
  const { isNewVersionAvailable, shouldShowFullAlert, reload } = useVersionCheck();
  const intl = useIntl();

  const showIcon = isNewVersionAvailable && !shouldShowFullAlert;

  if (!showIcon) {
    return null;
  }

  const handleClick = () => {
    reload('sidebar');
  };

  return (
    <Tooltip title={intl.formatMessage(versionUpdateTooltipMessage)} placement="right">
      <IconButton onClick={handleClick} color="warning">
        <NewReleasesIcon />
      </IconButton>
    </Tooltip>
  );
}
